import React from 'react';
import { InputNumber } from 'antd';
import PropTypes from 'prop-types';
import Label from '../../../../atoms/Label';
import { CustomText, CustomInput, InputPercentage } from '../../../../atoms';
import {
  VALUE_TYPE_MONEY,
  VALUE_TYPE_NUMBER,
  VALUE_TYPE_PERCENTAGE,
} from '../../../../../services/repository/settingRepository/objects/setting';

function Field({
  id,
  label,
  value,
  valueType,
  onChangeFieldValue,
  isEnabled,
  onBlurField,
}) {
  return (
    <Label
      label={
        <CustomText type="secondary" fontSize="12px" height="16px">
          {label}
        </CustomText>
      }
    >
      {valueType === VALUE_TYPE_MONEY && (
        <CustomInput
          id={id}
          prefix="R$"
          value={value}
          getValue={onChangeFieldValue(id)}
          onBlur={() => onBlurField(id)}
          disabled={!isEnabled}
        />
      )}
      {valueType === VALUE_TYPE_NUMBER && (
        <InputNumber
          id={id}
          data-testid={id}
          value={value}
          onChange={onChangeFieldValue(id)}
          onBlur={() => onBlurField(id)}
          type="number"
          min={0}
          disabled={!isEnabled}
        />
      )}
      {valueType === VALUE_TYPE_PERCENTAGE && (
        <InputPercentage
          id={id}
          value={value}
          onChange={onChangeFieldValue(id)}
          onBlur={() => onBlurField(id)}
          disabled={!isEnabled}
        />
      )}
    </Label>
  );
}

Field.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  valueType: PropTypes.string.isRequired,
  onChangeFieldValue: PropTypes.func.isRequired,
  value: PropTypes.number,
  onBlurField: PropTypes.func.isRequired,
  isEnabled: PropTypes.bool,
};

Field.defaultProps = {
  value: 0,
  isEnabled: true,
};

export default Field;
